import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { StoreLocation } from '../models/storeLocation';

@Injectable({ providedIn: 'root' })

export class StoreLocationService {

  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/storeLocations';
  }
 
  getAll(id: any): Observable<Array<StoreLocation>> {
    const url = this._ENDPOINT + '/?brandId=' + id;
    return this.http.get<Array<StoreLocation>>(url); 
  }

  getById(id: any): Observable<StoreLocation> {
    const url = this._ENDPOINT + '/' + id;
    return this.http.get<StoreLocation>(url);
  }

  /** POST: add a new storeLocation to the server */
  add(storeLocation: StoreLocation): Observable<StoreLocation> {
    return this.http.post<StoreLocation>(this._ENDPOINT, storeLocation, this.httpOptions).pipe(
      tap((newStoreLocation: StoreLocation) => this.log('added store location w/ id=${newStoreLocation.id}')),
      catchError(this.handleError<StoreLocation>('add'))
    );
  }

  /** DELETE: delete the storeLocation from the server */
  delete(id: number): Observable<StoreLocation> { 
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<StoreLocation>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted storeLocation id=${id}')),
      catchError(this.handleError<StoreLocation>('deleteStoreLocation'))
    );
  }

  /** PUT: update the storeLocation on the server */
  update(id: number, storeLocation: StoreLocation): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, storeLocation, this.httpOptions).pipe(
      tap(_ => this.log('updated storeLocation id=${storeLocation.Id}')),
      catchError(this.handleError<any>('updateStoreLocation'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a StoreLocationService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`StoreLocationService: ${message}`);
  }
}
